  class SkiCarousel extends HTMLElement {
    connectedCallback() {
      this.#scroll = this.querySelector('[ref="scrollContainer"], [ref="resultsScrollContainer"]');
      this.#prevBtn = this.querySelector('[ref="prevBtn"], [ref="resultsCarouselPrev"]');
      this.#nextBtn = this.querySelector('[ref="nextBtn"], [ref="resultsCarouselNext"]');

      if (!this.#scroll) return;

      this.#prevBtn?.addEventListener('click', () => this.#navigate(-1));
      this.#nextBtn?.addEventListener('click', () => this.#navigate(1));
      this.#scroll.addEventListener('scroll', () => this.#updateArrows(), { passive: true });

      this.#resizeObserver = new ResizeObserver(() => this.#updateArrows());
      this.#resizeObserver.observe(this.#scroll);

      this.#updateArrows();
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
    }

    reset() {
      if (!this.#scroll) return;
      this.#scroll.scrollTo({ left: 0, behavior: 'instant' });
      this.#updateArrows();
    }

    #navigate(direction) {
      const cards = this.#scroll.querySelectorAll('.custom-ski-collection__card-item:not([hidden])');
      if (!cards.length) return;

      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.#scroll.firstElementChild).gap) || 16;
      const scrollAmount = (cardWidth + gap) * direction;

      this.#scroll.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    #updateArrows() {
      if (!this.#scroll || !this.#prevBtn || !this.#nextBtn) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.#scroll;
      const canScroll = scrollWidth > clientWidth + 1;

      if (!canScroll) {
        this.#prevBtn.hidden = true;
        this.#nextBtn.hidden = true;
        return;
      }

      this.#prevBtn.hidden = scrollLeft <= 1;
      this.#nextBtn.hidden = scrollLeft + clientWidth >= scrollWidth - 1;
    }

    #scroll;
    #prevBtn;
    #nextBtn;
    #resizeObserver;
  }

  if (!customElements.get('ski-carousel')) {
    customElements.define('ski-carousel', SkiCarousel);
  }
